const translations = {
  'trinityCerttesol.seo.title':
    'Curso acreditado Trinity CertTESOL de 160 horas en Barcelona y Sevilla',
  'trinityCerttesol.seo.description': `El curso TEFL acreditado de 160 horas de TEFL Iberia en Barcelona y Sevilla es profesional, asequible, con grupos pequeños. ¡Reserva y ahorra 150 €!`,
  'trinityCerttesol.sec1.title': 'Curso Trinity CertTESOL',
  'trinityCerttesol.sec1.description':
    'Obtén una calificación TEFL reconocida internacionalmente en 4 semanas.',
  'trinityCerttesol.sec1.weeks': '4 semanas',
  'trinityCerttesol.sec1.hours': '160 horas de tiempo en el aula',
  'trinityCerttesol.sec1.cities': 'Barcelona',

  'trinityCerttesol.sec2.title': '¡Comienza Una Nueva Y Emocionante Carrera!    ',
  'trinityCerttesol.sec2.description':
    'El curso Trinity CertTESOL está considerado como el curso más completo para aquellas personas que se quieren desempeñar en la enseñanza del inglés y es reconocido en todo el mundo. Te preparará y calificará para encontrar trabajo aquí en Barcelona o donde sea que te lleven tus viajes.',
  'trinityCerttesol.sec2.benefitsTitle': 'Este curso es ideal para ti si:',
  'trinityCerttesol.sec2.benefit1': 'Nunca has enseñado antes o tienes poca experiencia formal.',
  'trinityCerttesol.sec2.benefit2':
    'Quieres maximizar tus oportunidades de trabajo con una formación de primera clase y una calificación Trinity CertTESOL reconocida internacionalmente.    ',
  'trinityCerttesol.sec2.benefit3': 'Necesitas ayuda con tu mudanza a Barcelona.',
  'trinityCerttesol.sec2.benefit4': 'Quieres experimentar la cultura local.',
  'trinityCerttesol.sec2.ben1.title': 'Calificación reconocida internacionalmente',
  'trinityCerttesol.sec2.ben1.text':
    '¿Barcelona? ¿Bangkok? ¿Brasil? El Trinity CertTESOL es aceptado en todo el mundo.',
  'trinityCerttesol.sec2.ben2.title': 'Experiencia práctica en el aula',
  'trinityCerttesol.sec2.ben2.text': 'Ganarás confianza enseñando a grupos de estudiantes reales.',
  'trinityCerttesol.sec2.ben3.title': 'Tamaños de grupos pequeños',
  'trinityCerttesol.sec2.ben3.text':
    'Nuestras clases tienen un máximo de 12 estudiantes, lo que da acceso a un instructor a todos.',
  'trinityCerttesol.sec2.ben4.title': 'Perspectivas laborales después de la graduación',
  'trinityCerttesol.sec2.ben4.text':
    'Trabajamos arduamente para asegurarnos de que todos nuestros estudiantes encuentren trabajo relevante después de la graduación.    ',

  'trinityCerttesol.sec3.title': '¿Qué está incluido?',
  'trinityCerttesol.sec3.benefit1': 'Curso y calificación Trinity CertTESOL de 160 horas.',
  'trinityCerttesol.sec3.benefit2': 'Tarifas de examen y certificado Trinity CertTESOL.',
  'trinityCerttesol.sec3.benefit3': 'Tutoría experta de profesores profesionales.',
  'trinityCerttesol.sec3.benefit4':
    'Acceso a nuestra hermosa biblioteca escolar, wifi de alta velocidad, computadoras.    ',
  'trinityCerttesol.sec3.benefit5':
    '6+ horas de práctica de enseñanza observada con estudiantes reales.',
  'trinityCerttesol.sec3.benefit6':
    'Contactos de trabajo y ayuda para la colocación: nuestra escuela colaboradora contrata exclusivamente a graduados de TEFL Iberia.    ',
  'trinityCerttesol.sec3.benefit7': 'Coordinador de curso dedicado.',
  'trinityCerttesol.sec3.benefit8': 'Desayuno previo al curso.',
  'trinityCerttesol.sec3.benefit9': 'Calendario social en la escuela.  ',
  'trinityCerttesol.sec3.fullPrice': 'PRECIO COMPLETO:',
  'trinityCerttesol.sec3.earlyBirdPrice': 'PRECIO ANTICIPADO:',
  'trinityCerttesol.sec3.payInFull': 'Pago completo 4 semanas antes',
  'trinityCerttesol.sec3.quotation':
    'Estoy muy contenta de haber decidido asistir a TEFL Iberia para mi certificación. Todo el personal es increíble. Los instructores son excelentes y la facultad es muy solidaria. Te ayudan en cada paso del camino, desde la reubicación hasta la ayuda para encontrar trabajo después de completar el curso. ¡Los recomiendo altamente!',
  'trinityCerttesol.sec7.title': 'Empieza tu Aventura en el Extranjero <accent>Hoy Mismo</accent>',
  'trinityCerttesol.sec8.title': 'Plan de estudios y horario del curso',
  'trinityCerttesol.sec8.description':
    'El curso Trinity CertTESOL tiene una duración de 160 horas y se lleva a cabo durante 4 semanas.<accent> El horario es de lunes a viernes de 09:30 a 18:00.</accent>',
  'trinityCerttesol.sec8.notification.title': '¿El inglés no es tu lengua materna?',
  'trinityCerttesol.sec8.notification.description':
    'Debes demostrar un nivel C1 para poder realizar el curso.',
  'btn.takeEnglisAssessment': 'Prueba nivel de inglés',
  'btn.downloadTrinitySyllabus': 'Descarga el plan de estudios de Trinity CertTESOL',
  'common.faqs': 'Preguntas frecuentes ',
  'trinityCerttesol.sec11.title': 'Otros <accent>cursos populares</accent>',
  'trinityCerttesol.sec11.description': 'Lleva tu formación al siguiente nivel con TEFL Iberia',
  'trinityCerttesol.sec11.course1': 'Curso Docente Avanzado',
  'trinityCerttesol.sec11.course2': 'Enseñanza a jóvenes estudiantes ',
  'trinityCerttesol.sec11.course3': 'Intensive Spanish Course',
  'trinityCerttesol.sec11.month': 'mes',
  'trinityCerttesol.sec11.days': 'curso de 3 días',
};

export default translations;
